import UnlockIcon from '@assets/icons/UnlockIcon'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { T, useT } from '@transifex/react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

type PublicPrivateFieldProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
}

const PublicPrivateField = <T extends FieldValues>({
  control,
  name,
}: PublicPrivateFieldProps<T>) => {
  const t = useT()
  const {
    field: { value, onChange },
  } = useController({ control, name })

  return (
    <>
      <Button
        id="btnPublicPrivate"
        sx={{ mt: 2 }}
        onClick={() => onChange(!value)}
        aria-label={value ? t('Set to private') : t('Set to public')}
        startIcon={value ? <UnlockIcon /> : <LockOutlinedIcon />}>
        {value ? <T _str="This post is public" /> : <T _str="This post is private" />}
      </Button>
      <Typography variant="body1"></Typography>
    </>
  )
}

export default PublicPrivateField
